import {
  PrimarySmallButton,
  SecondarySmallButton
} from 'components/ReusableComponents/Button/SmallButtons'

import { authenticationKinds } from '../constants'
import styles from '../MultiStepPMSLogin.module.scss'

const AuthenticationMethodSelector = ({ onSelect }) => (
  <div className={styles.stepActions}>
    <div className={styles.actionContainer}>
      <p className={styles.cardDescription}>
        Choose how this OHIP integration authenticates.
      </p>
      <div className={styles.inputContainer}>
        <PrimarySmallButton
          type="button"
          size="small"
          onClick={() => onSelect(authenticationKinds.direct)}
        >
          Client credentials
        </PrimarySmallButton>
        <SecondarySmallButton
          type="button"
          size="small"
          onClick={() => onSelect(authenticationKinds.legacy)}
        >
          Legacy API user
        </SecondarySmallButton>
      </div>
    </div>
  </div>
)

export default AuthenticationMethodSelector
